import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinSubscriptionsRoute: InvariantJiraRoute = {
	name: 'legacy-gin-subscriptions',
	path: '(/secure/|/)ViewSubscriptions([!%]?[\\w]*).jspa',
};
